<template>
    <div class="">
      <div class="list-card van-hairline--surround"  @click="linkTo(item)">
        <div class="list-line clear">
          <p class="list-title fl">门店:</p>
          <p class="list-content fl">{{item.deptName}}</p>
        </div>
        <div class="list-line clear">
          <p class="list-title fl">活动:</p>
          <p class="list-content fl">{{item.campName}}</p>
        </div>
        <div class="list-line clear">
          <p class="list-title fl">日期:</p>
          <p class="list-content fl">{{(item.campTime || "").replace(/-/g,'/').replace(',','-')}}</p>
        </div>
        <div class="list-line clear">
          <p class="list-title fl">地点:</p>
          <p class="list-content fl">{{item.U_CampPlace}}</p>
        </div>
        <div class="list-line clear">
          <p class="list-title fl">实际费用:</p>
          <p class="list-content fl">{{$numeral(item.totalCost).format('0,0.00')}}</p>
        </div>
        <div class="flex">
          <p  class=" fl">活动后30天销售情况:</p>
          <p class="list-content fl">{{item.monthSalesCnt <= 0 ? "未提交" : "已提交"}}</p>
        </div>

        <div class="list-status">
          {{item.approvalStatusName}}
          <p v-if="item.U_ApprovalStatus=='W'">({{item.auditName}})</p>
        </div>

      </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props:{
          item:Object,
        },
        methods:{
          linkTo(item){
            if(item.U_CreatedId==this.$wxuserUtil.getUserId()&&item.U_ApprovalStatus=="M"){
              this.$router.push('/active/reportApply?id='+item.campReportId)
            }else{
//                this.$router.push('/active/apply?id='+this.data.U_CampaignId)
              this.$router.push('/active/reportDetail?id='+item.campReportId)
            }
          }
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeList.less";
</style>



// WEBPACK FOOTER //
// src/components/active/component/reportCard.vue